import React, { useContext } from "react";
import GettingStartedContext from "../utils/GettingStartedContext";

const QuestionsIntro = () => {
    const { data, setQuestion } = useContext(GettingStartedContext);

    return (
        <div className="grid-container">
            <h2 className="gsa__form__title">{data.Title}</h2>
            <p className="gsa__form__sub-title">{data.Subtitle}</p>
            <p className="gsa__form-button-container text-center">
                <button
                    className="gsa__form-button button secondary"
                    id="NextQ_Start"
                    onClick={() => {
                        setQuestion(data.Questions[0]);
                    }}
                >
                    <span>{data.ButtonText}</span>
                </button>
            </p>
        </div>
    );
};

export default QuestionsIntro;
